import { ApiClient } from '@travel/api-client';
import { internalPrefix } from 'constants/api-prefix';
import { Certification } from 'Certification-Types';

export const ApiFetchCertification = (http: ApiClient): Promise<Certification[]> => {
  return http.get(`${internalPrefix}/certification`);
};
